import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import History from "./History";

const HistoryPage = () => {
  return (
    <NavHeightAdjust>
      <History />
    </NavHeightAdjust>
  );
};

export default HistoryPage;
